import { $body } from '../globals.js';
import components from '../components.js';

/*
    [data-show-answer]: Boolean
    [data-type]: 'checkbox' | 'radio'
    [data-answer]: 'any' | 'anyOrNone' - Use instead of individual [data-required] attributes on the items. Can be, used in the future, for more complex requirements


*/

var setAsComplete = function ($activity) {
    rebus.panels.setActivityAsComplete($activity, true);
};


export default {
    init: function () {
        var keyboard = true;
        var performSubmit = function ($submit, $activity, $init) {
            var result, $response;
            $activity = $activity || $submit.closest('[data-activity="match-quiz"]');
            result = getResult($activity);
            var $stored_solution = new Array();
            if (rebus.stateHelper.get()[$activity.data('storeas')] ) {
                $stored_solution = String(rebus.stateHelper.get()[$activity.data('storeas')]).split('');
            }
            
            $activity.attr('data-correct', result).addClass('activity-submit');
            $activity.find('.response').removeClass('response');
            var $state = rebus.stateHelper.getElementDetails($activity);
            $state = $state.state;

            $activity.find('.match-btn').each(function ($optionIdx) {
                $(this).removeClass('row-correct');
                if ($(this).hasClass('row-wrong')) {
                    $(this).addClass('row-solved');
                }
                $(this).removeClass('row-wrong');
                var $answer = String($optionIdx);
                if ($(this).data('answer')) {
                    $answer = String($(this).data('answer'));
                }
                $answer = $answer.split(',');
                if ($answer.indexOf(String($state.charAt($optionIdx))) >=0) {
                    $(this).addClass('row-correct');
                } else {
                    $(this).addClass('row-wrong');
                }
                if ($stored_solution.indexOf(String($optionIdx)) >= 0) {
                    $(this).addClass('row-solved');
                }
            });
            var $answers = $state.split('');
            solveRow($activity, $answers);
            if (result === true) {
                $response = $activity.find('.match-complete');
            } else {
                $response = $activity.find('.match-incorrect');
            }

            $response.addClass('response');


            if ($submit) {
                $submit.parent().remove();
            }
            
            setAsComplete($activity);
            if (!result) {
                addSolve($activity);
            }
            //Manage focus
            if (!$init) {
                if ($response.find('.audio-control').length > 0) {
                    $response.find('.audio-control').first().removeAttr('tabIndex');
                    $response.find('.audio-control').first().attr('tabIndex', '0');
                    $response.find('.audio-control').first().focus();
                } else {
                    $response.removeAttr('tabIndex');
                    $response.attr('tabIndex', '0');
                    $response[0].focus();
                }
            }
        };
        var nextOption = function ($activity, $init) {
            var $state = rebus.stateHelper.getElementDetails($activity)['state'];
            var $init = $init || false;
            var $index, $answers = new Array();
            if ($state == undefined) {
                $index  = 0;
            } else {
                $index = $state.length;
                $answers = $state.split('');
            }
            var $length = $activity.find('.match-options div').length;
            var $buttons = $activity.find('.match-btns');
            
            if ($index >= $length) {
                submitReady($activity, $init);
            } else {
                $buttons.find('.match-btn').each(function () {
                    var $button = $(this);
                    if ($button.attr('data-index') == $index) {
                        $button.addClass('active');
                        addOptions($activity, $button);
                        if (!$init) {
                            $button.find('div').first().focus()
                        }
                    }
                });
            }
            solveRow($activity, $answers);

        }
        var solveRow = function($activity, $answers) {
            var $options = $activity.find('.match-option');
            var $answer, $p, $option, $span;
            var $colunm = $activity.data('colunm2');
            $activity.find('.match-btn').each(function ($optionIdx) {
                var $row = $(this);
                if ($answers.length > $optionIdx) {
                    $row.addClass('row-complete');
                    $answer = $activity.find('.match-options [data-index="'+$answers[$optionIdx]+'"]');
                    $option = $row.find('.match-option');
                    $option.addClass('cell-complete');
                    removeOptions($option[0]);
                    $p = document.createElement('p');
                    $span = document.createElement('span');
                    $span.classList.add('sr-only');
                    if ($row.hasClass('row-correct')) {
                        $span.textContent = "Correct "+$colunm + " for term "+($optionIdx+1) +": " ;
                    } else if ($row.hasClass('row-wrong')) {
                        $span.textContent = "Incorrect "+$colunm + " for term "+($optionIdx+1) +": " ;
                    } else {
                        $span.textContent = "Selected "+$colunm + " for term "+($optionIdx+1) +": " ;
                    }
                    
                    $p.appendChild($span);
                    $span = document.createElement('span');
                    $span.textContent = $answer[0].textContent;
                    $p.appendChild($span);
                    $option[0].appendChild($p);
                }
            });
        }
        var addOptions = function ($activity, $button) {
            var $options = $activity.find('.match-options div');
            var $colunm = $activity.data('colunm2');
            var $target = $button.find('.match-option')[0];
            removeOptions($target);
            var $btn, $option, $optionId, $i, $span;
            for($i = 0;$i < $options.length; $i++) {
                $optionId = $activity.data('storeid') + '_o' + $i;
                $option = $activity.find('.match-options [data-order="'+$i+'"]')[0];
                $btn = document.createElement('button');
                $btn.classList.add('btn-match');
                $btn.setAttribute('data-match', $option.getAttribute('data-index'));
                $btn.setAttribute('type', 'button');  
                $span = document.createElement('span');
                $span.classList.add('sr-only');
                $span.textContent = $colunm + " "+($i+1)+": ";
                $btn.appendChild($span);
                $span = document.createElement('span');
                $span.textContent = $option.textContent;
                $btn.appendChild($span);
                $btn.addEventListener('click', function () {
                    selectOption($(this));
                });
                $target.appendChild($btn);
            }
        }
        var removeOptions = function ($ele) {
            while ($ele.lastChild) {
                $ele.removeChild($ele.lastChild);
            }
        }
        var selectOption = function ($btn) {
            $('body').off('.match-btn');
            $('body').off('[data-match]');
            var $activity = $btn.closest('[data-activity="match-quiz"]');
            var $state = rebus.stateHelper.getElementDetails($activity)['state'];
            var $state = ($state == undefined) ? $btn.data('match') : $state+$btn.data('match');
            rebus.stateHelper.setElementState($activity, String($state));
            rebus.stateHelper.save();
            solveMatch($activity, $btn);
            nextOption($activity);
        }
        var solveMatch = function($activity, $btn) {
            var $row = $btn.closest('.match-btn');
            var $optionIdx = $row.data('index');
            var $colunm = $activity.data('colunm2');
            $row.addClass('row-complete');
            var $parent = $btn.closest('.match-option');
            var $answer = $btn[0].getAttribute('data-match');
            $activity[0].focus();
            removeOptions($parent[0]);
            var $options = $activity.find('.match-options div');
            var $p = document.createElement('p');
            $p = document.createElement('p');
            var $span = document.createElement('span');
            $span.classList.add('sr-only');
            $span.textContent = "Selected "+$colunm + " for term "+($optionIdx+1) +": " ;
            $p.appendChild($span);
            $span = document.createElement('span');
            $span.textContent = $answer[0].textContent;
            $p.appendChild($span);
            $parent[0].appendChild($p);
            var $icon = addSVGIcon('tick');
            $parent[0].appendChild($icon);
        }
        var addSVGIcon = function($type = 'tick') {
            var $tick = document.createElement('svg');
            $tick.setAttribute('focusable', 'false');
            $tick.setAttribute('role', 'presentation');
            $tick.setAttribute('version', '1.1');
            $tick.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            $tick.setAttribute('focusable', 'false');
            $tick.setAttribute('aria-hidden', 'true');
            var $use = document.createElement('use');
            $use.setAttribute('href', 'content/images/icons.svg#icon-tick');
            $use.setAttribute('xlink:href', 'content/images/icons.svg#icon-tick');
            $tick.appendChild($use);
            return $tick;
        }
        var addSolve = function($activity, $init) {
            var $div = document.createElement('div');
            $div.classList.add('text-right');
            var $btn = document.createElement('button');
            $btn.setAttribute('type', 'button');
            $btn.classList.add('btn', 'btn-lg', 'btn-primary', 'match-quiz-solve', 'pink');
            var $ele = document.createElement('span');
            $ele.textContent = 'Show me the answers';
            $btn.appendChild($ele);
            $btn.addEventListener('click', function () {
                checkSolution($activity);
                var $solution = buildSolution($activity);
                rebus.stateHelper.setElementState($activity, $solution);
                rebus.stateHelper.save();
                $(this).parent().remove();
                nextOption($activity);
                performSubmit(null, $activity, false);
                if ($activity.data('hidesolved')) {
                    $activity.find('.match-complete').removeClass('response');
                }
                $activity.find('.match-btn').first().find('div').first().focus();
            });
            $div.appendChild($btn);

            var $submit = $activity.find('.match-incorrect')[0];
            $submit.after($div);

        }
        var submitReady = function($activity, $init) {
            var $panel = $activity.closest('section');
            var $div = document.createElement('div');
            $div.classList.add('text-right');
            var $btn = document.createElement('button');
            $btn.setAttribute('type', 'button');
            $btn.classList.add('btn', 'btn-lg', 'btn-primary', 'match-quiz-submit', 'pink');
            var $ele = document.createElement('span');
            $ele.textContent = ($activity.data('submit') || 'Check my answer');
            $btn.appendChild($ele);
            $btn.addEventListener('click', function () {
                performSubmit($(this), null, false);
            });
            $div.appendChild($btn);
            
            if ($panel.data('state') == 1 ) {
                performSubmit(null, $activity, true);
            } else if(!$activity.hasClass('activity-done')){
                var $submit = $activity.find('.match-btns')[0];
                $submit.appendChild($div);
                if (!$init) {
                    $($submit).find('button').first().focus(); 
                }
            }
        }
        var buildSolution = function($activity) {
            var $solution = '';
            var $answer, $check;
            var $state = rebus.stateHelper.getElementDetails($activity);
            $state = String($state.state).split('');
            $activity.find('.match-btn').each(function ($optionIdx) {
                var $answer = String($optionIdx);
                if ($(this).data('answer')) {
                    $check = String($(this).data('answer')).split(',');
                    $answer = $state[$optionIdx];
                    if ($check.indexOf($state[$optionIdx]) == -1) {
                        $answer = String($(this).data('answer')).split(',')[0];
                    }
                }
                $solution += $answer;
            });

            return $solution;
        }
        var checkSolution = function($activity) {
            var $solution = buildSolution($activity);
            $solution = $solution.split('')
            var $i, $solveCheck = '';
            var $state = rebus.stateHelper.getElementDetails($activity);
            $state = String($state.state).split('');
            for($i = 0; $i < $solution.length; $i++ ) {
                if ($solution[$i] != $state[$i]) {
                    $solveCheck += $i;
                }
            }
            var $obj = {storeas : $activity.data('storeas') };
            $obj.data = function($id) {
                return this.storeas;
            }
            $obj.attr = function($id, $val) {};
            rebus.stateHelper.setElementState($obj, $solveCheck);
            rebus.stateHelper.save();
        }
        var getResult = function($activity) {
            var $solution = buildSolution($activity);
            return $solution == rebus.stateHelper.getElementDetails($activity).state;
        }
        var shuffle = function ($arr) {
            var $cIndex = $arr.length,  $rIndex;
            // While there remain elements to shuffle.
            while ($cIndex != 0) {
                $rIndex = Math.floor(Math.random() * $cIndex);
                $cIndex--;
                [$arr[$cIndex], $arr[$rIndex]] = [$arr[$rIndex], $arr[$cIndex]];
            }
            return $arr;
        }

        $('[data-activity="match-quiz"]').each(function () {
            var $activity = $(this),
                $buttons = $activity.find('.match-btn'),
                $options = $activity.find('.match-options'),
                details = rebus.stateHelper.getElementDetails($activity),
                $order = new Array();
            $activity.attr('data-temp', '')
            $buttons.each(function ($index) {
                var $button = $(this);
                $button.attr('data-index', $index);
            });

            $options.find('div').each(function ($index) {
                $order.push($index);
                var $option = $(this);
                $option.attr('data-index', $index);
                $option.attr('data-order', $index);
            });
            if ($activity.data('random') == true) {
                $order = shuffle($order);
                $options.find('div').each(function ($index) {
                    var $option = $(this);
                    $option.attr('data-order', $order[$index]);
                });
            }

            nextOption($activity, true);
        });
    },
    resetActivity: function ($activity) {

    }

};